'use client';

import React from 'react';
import { StyledDiv, StyledEmptyStar, StyledHalfStar, StyledStar } from './ReviewStars.styled';
export const ReviewStars = _ref => {
  let {
    stars,
    width
  } = _ref;
  const halfStar = stars % 1 !== 0;
  const fullStar = Math.floor(stars);
  const emptyStar = 5 - (fullStar + (halfStar ? 1 : 0));
  return /*#__PURE__*/React.createElement(StyledDiv, null, [...Array(fullStar)].map((e, i) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React.createElement(StyledStar, {
    $width: width,
    key: i
  })), halfStar && /*#__PURE__*/React.createElement(StyledHalfStar, {
    $width: width
  }), [...Array(emptyStar)].map((e, i) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React.createElement(StyledEmptyStar, {
    $width: width,
    key: i
  })));
};
export default ReviewStars;